import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "minuteByMinuteBlock",
  class: "minute-by-minute"
}
const _hoisted_2 = {
  key: 1,
  class: "minute-by-minute__block"
}
const _hoisted_3 = { class: "minute-by-minute__top" }
const _hoisted_4 = { class: "minute-by-minute__ago" }
const _hoisted_5 = {
  key: 0,
  class: "minute-by-minute__author"
}
const _hoisted_6 = { class: "minute-by-minute__title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Tovább a cikkre ")
const _hoisted_10 = { class: "minute-by-minute__block" }
const _hoisted_11 = { class: "minute-by-minute-notification__wrap" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "minute-by-minute-notification__text" }, "1 friss hír érkezett, kattints a megtekintéshez!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_card_left_img = _resolveComponent("content-card-left-img")!
  const _component_i18n_d = _resolveComponent("i18n-d")!
  const _component_nav_link = _resolveComponent("nav-link")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedContents, (content, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (_ctx.isLinkable(content))
          ? (_openBlock(), _createBlock(_component_content_card_left_img, {
              key: 0,
              class: "minute-by-minute__block",
              content: content,
              "show-title": true,
              "show-tag": true,
              "show-lead": true,
              "show-image": true,
              "show-duration": true
            }, null, 8, ["content"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getContentTimeAgo(content)), 1),
                (content.authors && content.authors.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.authors, (author) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: author.id
                        }, [
                          _createTextVNode(_toDisplayString(author.name), 1)
                        ], 64))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_i18n_d, {
                  tag: "span",
                  class: "minute-by-minute__date",
                  value: _ctx.getContentReleaseDate(content),
                  format: "long"
                }, {
                  hour: _withCtx((props) => [
                    _createTextVNode(" - " + _toDisplayString(props.hour), 1)
                  ]),
                  _: 2
                }, 1032, ["value"])
              ]),
              _createElementVNode("h1", _hoisted_6, [
                (_ctx.isLinkable(content))
                  ? (_openBlock(), _createBlock(_component_nav_link, {
                      key: 0,
                      to: _ctx.getContentUrl(content)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getContentTitle(content)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.getContentTitle(content)), 1)
                    ], 64))
              ]),
              _createElementVNode("div", {
                class: "minute-by-minute__content",
                innerHTML: _ctx.getContentBody(content)
              }, null, 8, _hoisted_7),
              (_ctx.isLinkable(content))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_nav_link, {
                      to: _ctx.getContentUrl(content),
                      class: "button-show-all"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createVNode(_component_ArrowRight, { class: "button-show-all__icon" })
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ], 64))
    }), 128)),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_pagination, {
        page: _ctx.paginationPage,
        limit: _ctx.length,
        "total-count": _ctx.contentFeed?.totalCount,
        "page-param-name": "oldal"
      }, null, 8, ["page", "limit", "total-count"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["minute-by-minute-notification", { 'minute-by-minute-notification--open': _ctx.feedNotificationOn}])
    }, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("button", {
          class: "minute-by-minute-notification__refresh",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshPage()))
        }, "Frissítés")
      ]),
      _createVNode(_component_Close, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeFeedNotification()))
      })
    ], 2)
  ], 512))
}